import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { ResearchMap } from '../components/research/ResearchMap';
import { ResearchConcepts } from '../components/research/ResearchConcepts';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-3417" data-mp="30j7mun7x706v" />
      <ResearchMap data-id="element-3418" data-mp="30jqth7s4e25l" />
      <ResearchSkp data-id="element-3419" data-mp="30k8wcn9afemh" />
      <ResearchPriorities data-id="element-3420" data-mp="13q5u4fjpzew7" />
      <ResearchConcepts data-id="element-3421" data-mp="13okvoeuabbt2" />
      <RelatedInitiative name="Cognocracy" body="A civic initiative that draws on this research, including the NCJI assessment model and its open questions. Its associated government solution is NCDS." href="/ecosystem/cognocracy" data-id="element-3422" data-mp="13ouoea6prx2g" />
      <section aria-labelledby="related-governance" className="bg-white border-t border-line py-20 lg:py-24" data-id="element-3423" data-mp="bxg0k8alr3hx">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-3424" data-mp="3u3b5jg177zef">
          <h2 id="related-governance" className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-3425" data-mp="2w8c0hxw1h11">
            Related governance research
          </h2>
          <p className="lg:col-span-7 lg:pt-1 text-lg text-ink-muted leading-relaxed" data-id="element-3426" data-mp="gvpw4k08o642">
            The sections below explore how SyNeural’s architecture could relate
            to the Cognarchic State, a separate governance proposal. They are
            research material, not part of SyNeural’s current products or
            demos.
          </p>
        </div>
      </section>
      <CognarchicFoundation data-id="element-3427" data-mp="1econk06bndim" />
      <OperationalSystems data-id="element-3428" data-mp="1o7dqmjjppfx6" />
      <ResearchTesting data-id="element-3429" data-mp="1o5j4j1wpfhri" />
    </>;
}